module.exports = __webpack_public_path__ + "static/images/delivery-option.1AUZLFw.svg";